import { home_select_children, bigScreen_select_children, app_select_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxSelect = {
  name: "cxSelect",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "下拉框",
        children: app_select_children,
        group: "element",
     // enable(params) {
        //   return params.admin
        // },
        sort: 100
      }
    ],
    bigScreen: [
      {
        name: "下拉框",
        children: bigScreen_select_children,
        group: "component",
        sort: 50
      }
    ],
    portal: [
      {
        name: "下拉框",
        children: home_select_children,
        group: "element",
     // enable(params) {
        //   return params.admin
        // },
        sort: 100
      }
    ]
  },
  toolbars: [
    {
      name: "cxSelect",
      label: "下拉框",
      comp: {
        selectComponentData: () => import("./toolbars/select-options-data.vue"),
        selectComponentSetting: () => import("./toolbars/select-options-setting.vue"),
        selectComponentStyle: () => import("./toolbars/select-options-style.vue"),
        selectComponentConfig: () => import("./toolbars/select-options-config.vue")
      }
    }
  ]
}

export default cxSelect
